import { Component, OnInit } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { Observable, map, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Platform } from '@angular/cdk/platform';
import { Query, Terms } from '../../../graphql/generated/generated-types';
import { GET_TERMS } from '../../../routes/terms-and-conditions/terms.graphql';
import { DataService } from '../../../core/providers/data/data.service';
export interface TermsDialogData {
  cancelBtnText?: string,
  approveBtnText?: string,
}

@Component({
  selector: 'app-terms-dialog',
  standalone: true,
  imports: [ButtonModule, RippleModule, ScrollPanelModule],
  templateUrl: './terms-dialog.component.html',
  styleUrl: './terms-dialog.component.scss'
})
export class TermsDialogComponent implements OnInit {
  public dialogData: TermsDialogData;

  public externalFastPartsHTMLcontent: any;
  public pagesContainerContent: string = '';

  constructor(private dialogRef: DynamicDialogRef, private config: DynamicDialogConfig, private dataService: DataService, private platform: Platform){
    this.dialogData = this.config.data;
  }

  ngOnInit(): void {
    if(this.platform.isBrowser){
      this.subscribeToTermsAndConditions();
    }
  }



  public subscribeToTermsAndConditions(){
    this.getTermsAndCondition().pipe(take(1)) .subscribe({
        next : (response: Terms) => {
          if(response?.content){
            this.pagesContainerContent = this.extractPagesContainer(response.content);
          }
        }
    })
  }

  public getTermsAndCondition(): Observable<Terms> {
    return this.dataService.query<Query>(GET_TERMS, {}, 'cache-and-network').pipe(
      map((data) => data.terms as Terms))
  }

  extractPagesContainer(htmlContent: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');

    const pagesContainer = doc.getElementById('PAGES_CONTAINER');
    if (pagesContainer) {
      return pagesContainer.outerHTML;
    } else {
      console.error('PAGES_CONTAINER not found in the HTML content.');
      return '';
    }
  }




  public closeDialog(){
    this.dialogRef.close()
  }

  public agreeAndClose(){
    this.dialogRef.close(true)
  }
}
